import { store } from '@/store'
import { officeApi } from '@/store/services'
import { toOptions } from '@/utils'
import { useEffect, useState } from 'react'
import { createSearchParams } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { SelectWrapper } from '../wrapper'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const MultiOfficeSelector = ({ value, onChange, defaultValue = [], required = false }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState(defaultValue)
  const officeLoadOptions = async (search, _loadedOptions, { page }) => {
    const searchParams = createSearchParams({ page, q: search, 'order[field]': 'name', 'order[sort]': 'asc' }).toString()

    const { offices, meta } = await store.dispatch(
      officeApi.endpoints.getOffices.initiate(`?${searchParams}`, { subscribe: true })
    ).unwrap()

    const officeOptions = toOptions({ data: offices })
    const hasMore = page < meta.pagination.total_pages

    return {
      options: officeOptions,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  const getCurrentOffice = async (ids) => {
    const searchParams = createSearchParams({
      'id[]': ids
    })
    const { offices = {} } = await store.dispatch(
      officeApi.endpoints.getOffices.initiate(`?${searchParams}`)
    ).unwrap()

    setSelectedOption(toOptions({ data: offices }))
  }

  // Si el selector esta en un popover o modal, se pierde el selectedOption
  // Esta es una forma para rescatarlo si es que se pierde el estado.
  useEffect(() => {
    if (!value) return
    if (value.length === selectedOption.length) return

    getCurrentOffice(value)
  }, [value])

  const handleOfficeChange = (option) => {
    console.log('option', JSON.stringify(option))
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <SelectWrapper label='Dependencia' required={required}>
      {(styles) => (
        <AsyncPaginate
          isMulti
          loadingMessage={() => t('select.loading')}
          value={Object.keys(selectedOption).length ? selectedOption : null}
          debounceTimeout={600}
          placeholder={t('select.one')}
          onChange={handleOfficeChange}
          loadOptions={officeLoadOptions}
          styles={styles}
          menuPortalTarget={document.body}
          additional={{
            page: 1
          }}
        />
      )
      }
    </SelectWrapper>
  )
}

MultiOfficeSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
  defaultValue: PropTypes.array
}
